import React, { useEffect } from "react";
import { Routes, Route, useNavigate } from "react-router-dom";
import { Layout } from "./layout";
import Overview from "../modules/overview";
import Login from "../modules/login";
import ResetPassword from "../modules/login/resetPassword";
import Invoicing from "../modules/invoicing";
// import Properties from "../modules/properties"; // commented out per request (preserve component but do not use)
import ClientConnection from "../modules/clientconnection";
import Quotes from "../modules/quotes";
import Scheduling from "../modules/scheduling";
import Pages from "../pages";

const Routing = () => {
  const RequireAuth: React.FC<{ children: React.ReactNode }> = ({
    children,
  }) => {
    const navigate = useNavigate();
    const requiredToken = window.localStorage.getItem("ID");

    useEffect(() => {
      if (!requiredToken) {
        navigate("/");
      }
    }, [requiredToken]);

    if (requiredToken) {
      return <>{children}</>;
    }
    return null;
  };
  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/login" element={<Login />} />
      <Route path="/reset" element={<ResetPassword />} />
      <Route path="/pages" element={<Pages />} />
      <Route
        path="/overview"
        element={
          <RequireAuth>
            <Layout>
              <Overview />
            </Layout>
          </RequireAuth>
        }
      />
      <Route
        path="/invoicing"
        element={
          <RequireAuth>
            <Layout>
              <Invoicing />
            </Layout>
          </RequireAuth>
        }
      />
      <Route
        path="/clientconnection"
        element={
          <RequireAuth>
            <Layout>
              <ClientConnection />
            </Layout>
          </RequireAuth>
        }
      />
      <Route
        path="/quotes"
        element={
          <Layout>
            <Quotes />
          </Layout>
        }
      />
      <Route
        path="/scheduling"
        element={
          <RequireAuth>
            <Layout>
              <Scheduling />
            </Layout>
          </RequireAuth>
        }
      />
      <Route path="/forgotpassword" element={<Login />} />
    </Routes>
  );
};
export default Routing;
